// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1xtuY","containerItemsCenter":"Skeleton_containerItemsCenter__1dyvZ"};